import * as types from '../../components/Question/types';
import * as mathSymbols from '../../mathSymbols';

export const add0or1or2Questions: types.Question[] = [
  {
    numA: 0, sign: mathSymbols.ADD, numB: 2, answer: 2, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 2, answer: 3, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 2, answer: 4, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 2, answer: 5, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 2, answer: 6, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 2, answer: 7, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 2, answer: 8, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 2, answer: 9, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 2, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 2, answer: 11, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 2, answer: 12, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 1, answer: 1, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 1, answer: 2, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 1, answer: 3, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 1, answer: 4, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 1, answer: 5, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 1, answer: 6, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 1, answer: 7, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 1, answer: 8, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 1, answer: 9, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 1, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 1, answer: 11, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 0, answer: 0, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 0, answer: 1, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 0, answer: 2, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 0, answer: 3, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 0, answer: 4, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 0, answer: 5, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 0, answer: 6, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 0, answer: 7, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 0, answer: 8, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 0, answer: 9, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 0, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 2, answer: 2, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 2, answer: 3, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 2, answer: 4, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 2, answer: 5, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 2, answer: 6, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 2, answer: 7, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 2, answer: 8, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 2, answer: 9, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 2, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 2, answer: 11, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 2, answer: 12, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 1, answer: 1, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 1, answer: 2, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 1, answer: 3, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 1, answer: 4, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 1, answer: 5, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 1, answer: 6, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 1, answer: 7, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 1, answer: 8, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 1, answer: 9, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 1, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 1, answer: 11, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 0, answer: 0, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 0, answer: 1, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 0, answer: 2, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 0, answer: 3, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 0, answer: 4, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 0, answer: 5, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 0, answer: 6, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 0, answer: 7, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 0, answer: 8, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 0, answer: 9, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 0, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 2, answer: 2, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 2, answer: 3, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 2, answer: 4, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 2, answer: 5, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 2, answer: 6, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 2, answer: 7, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 2, answer: 8, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 2, answer: 9, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 2, answer: 10, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 2, answer: 11, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 2, answer: 12, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 1, answer: 1, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 1, answer: 2, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 1, answer: 3, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 1, answer: 4, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 1, answer: 5, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 1, answer: 6, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 1, answer: 7, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 1, answer: 8, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 1, answer: 9, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 1, answer: 10, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 1, answer: 11, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 0, answer: 0, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 0, answer: 1, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 0, answer: 2, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 0, answer: 3, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 0, answer: 4, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 0, answer: 5, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 0, answer: 6, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 0, answer: 7, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 0, answer: 8, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 0, answer: 9, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 0, answer: 10, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 2, answer: 2, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 2, answer: 3, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 2, answer: 4, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 2, answer: 5, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 2, answer: 6, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 2, answer: 7, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 2, answer: 8, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 2, answer: 9, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 2, answer: 10, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 2, answer: 11, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 2, answer: 12, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 1, answer: 1, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 1, answer: 2, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 1, answer: 3, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 1, answer: 4, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 1, answer: 5, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 1, answer: 6, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 1, answer: 7, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 1, answer: 8, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 1, answer: 9, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 1, answer: 10, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 1, answer: 11, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 0, answer: 0, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 0, answer: 1, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 0, answer: 2, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 0, answer: 3, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 0, answer: 4, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 0, answer: 5, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 0, answer: 6, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 0, answer: 7, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 0, answer: 8, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 0, answer: 9, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 0, answer: 10, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question
];

export const bondsTo10Questions: types.Question[] = [
  {
    numA: 0, sign: mathSymbols.ADD, numB: 10, answer: 10, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 10, answer: 9, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 10, answer: 8, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 10, answer: 7, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 10, answer: 6, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 10, answer: 5, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 10, answer: 4, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 10, answer: 3, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 10, answer: 2, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 10, answer: 1, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 0, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 10, answer: 10, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 10, answer: 9, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 10, answer: 8, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 10, answer: 7, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 10, answer: 6, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 10, answer: 5, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 10, answer: 4, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 10, answer: 3, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 10, answer: 2, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 10, answer: 1, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 0, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 10, answer: 10, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 10, answer: 9, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 10, answer: 8, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 10, answer: 7, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 10, answer: 6, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 10, answer: 5, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 10, answer: 4, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 10, answer: 3, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 10, answer: 2, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 10, answer: 1, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 0, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 10, answer: 10, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 10, answer: 9, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 10, answer: 8, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 10, answer: 7, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 10, answer: 6, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 10, answer: 5, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 10, answer: 4, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 10, answer: 3, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 10, answer: 2, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 10, answer: 1, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 0, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question
];

export const bondsTo20Questions: types.Question[] = [
  {
    numA: 0, sign: mathSymbols.ADD, numB: 20, answer: 20, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 20, answer: 19, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 20, answer: 18, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 20, answer: 17, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 20, answer: 16, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 20, answer: 15, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 20, answer: 14, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 20, answer: 13, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 20, answer: 12, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 20, answer: 11, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 20, answer: 10, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 20, answer: 9, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 20, answer: 8, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 20, answer: 7, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 20, answer: 6, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 20, answer: 5, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 20, answer: 4, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 20, answer: 3, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 20, answer: 2, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 20, answer: 1, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 20, answer: 0, format: types.Format.Equation5, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 20, answer: 20, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 20, answer: 19, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 20, answer: 18, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 20, answer: 17, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 20, answer: 16, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 20, answer: 15, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 20, answer: 14, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 20, answer: 13, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 20, answer: 12, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 20, answer: 11, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 20, answer: 10, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 20, answer: 9, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 20, answer: 8, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 20, answer: 7, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 20, answer: 6, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 20, answer: 5, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 20, answer: 4, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 20, answer: 3, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 20, answer: 2, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 20, answer: 1, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 20, answer: 0, format: types.Format.Equation6, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 20, answer: 20, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 20, answer: 19, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 20, answer: 18, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 20, answer: 17, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 20, answer: 16, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 20, answer: 15, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 20, answer: 14, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 20, answer: 13, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 20, answer: 12, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 20, answer: 11, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 20, answer: 10, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 20, answer: 9, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 20, answer: 8, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 20, answer: 7, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 20, answer: 6, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 20, answer: 5, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 20, answer: 4, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 20, answer: 3, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 20, answer: 2, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 20, answer: 1, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 20, answer: 0, format: types.Format.Equation7, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 20, answer: 20, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 20, answer: 19, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 20, answer: 18, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 20, answer: 17, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 20, answer: 16, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 20, answer: 15, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 20, answer: 14, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 20, answer: 13, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 20, answer: 12, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 20, answer: 11, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 20, answer: 10, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 20, answer: 9, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 20, answer: 8, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 20, answer: 7, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 20, answer: 6, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 20, answer: 5, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 20, answer: 4, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 20, answer: 3, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 20, answer: 2, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 20, answer: 1, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 20, answer: 0, format: types.Format.Equation8, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question
];

export const bondsTo100TensQuestions: types.Question[] = [
  {
    numA: 0, sign: mathSymbols.ADD, numB: 100, answer: 100, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 100, answer: 90, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 100, answer: 80, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 100, answer: 70, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 100, answer: 60, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 100, answer: 50, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 100, answer: 40, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 100, answer: 30, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 100, answer: 20, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 100, answer: 10, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 100, sign: mathSymbols.ADD, numB: 100, answer: 0, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 100, answer: 100, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 100, answer: 90, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 100, answer: 80, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 100, answer: 70, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 100, answer: 60, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 100, answer: 50, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 100, answer: 40, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 100, answer: 30, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 100, answer: 20, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 100, answer: 10, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 100, sign: mathSymbols.ADD, numB: 100, answer: 0, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 100, answer: 100, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 100, answer: 90, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 100, answer: 80, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 100, answer: 70, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 100, answer: 60, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 100, answer: 50, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 100, answer: 40, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 100, answer: 30, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 100, answer: 20, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 100, answer: 10, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 100, sign: mathSymbols.ADD, numB: 100, answer: 0, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 100, answer: 100, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 100, answer: 90, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 100, answer: 80, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 100, answer: 70, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 100, answer: 60, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 100, answer: 50, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 100, answer: 40, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 100, answer: 30, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 100, answer: 20, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 100, answer: 10, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 100, sign: mathSymbols.ADD, numB: 100, answer: 0, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question
];

export const bondsTo100OnesQuestions: types.Question[] = [
  {
    numA: 0, sign: mathSymbols.ADD, numB: 100, answer: 100, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 100, answer: 99, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 100, answer: 98, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 100, answer: 97, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 100, answer: 96, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 100, answer: 95, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 100, answer: 94, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 100, answer: 93, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 100, answer: 92, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 100, answer: 91, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 100, answer: 90, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 100, answer: 89, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 100, answer: 88, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 100, answer: 87, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 100, answer: 86, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 100, answer: 85, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 100, answer: 84, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 100, answer: 83, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 100, answer: 82, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 100, answer: 81, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 100, answer: 80, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 100, answer: 79, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 100, answer: 78, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 100, answer: 77, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.ADD, numB: 100, answer: 76, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.ADD, numB: 100, answer: 75, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.ADD, numB: 100, answer: 74, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.ADD, numB: 100, answer: 73, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.ADD, numB: 100, answer: 72, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.ADD, numB: 100, answer: 71, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 100, answer: 70, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 100, answer: 69, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 100, answer: 68, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 100, answer: 67, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.ADD, numB: 100, answer: 66, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.ADD, numB: 100, answer: 65, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.ADD, numB: 100, answer: 64, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.ADD, numB: 100, answer: 63, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.ADD, numB: 100, answer: 62, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.ADD, numB: 100, answer: 61, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 100, answer: 60, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 100, answer: 59, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 100, answer: 58, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 100, answer: 57, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.ADD, numB: 100, answer: 56, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.ADD, numB: 100, answer: 55, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.ADD, numB: 100, answer: 54, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.ADD, numB: 100, answer: 53, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.ADD, numB: 100, answer: 52, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.ADD, numB: 100, answer: 51, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 100, answer: 50, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 100, answer: 49, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 100, answer: 48, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 100, answer: 47, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.ADD, numB: 100, answer: 46, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.ADD, numB: 100, answer: 45, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.ADD, numB: 100, answer: 44, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.ADD, numB: 100, answer: 43, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.ADD, numB: 100, answer: 42, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.ADD, numB: 100, answer: 41, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 100, answer: 40, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 100, answer: 39, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 100, answer: 38, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 100, answer: 37, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.ADD, numB: 100, answer: 36, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.ADD, numB: 100, answer: 35, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.ADD, numB: 100, answer: 34, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.ADD, numB: 100, answer: 33, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.ADD, numB: 100, answer: 32, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.ADD, numB: 100, answer: 31, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 100, answer: 30, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 100, answer: 29, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 100, answer: 28, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 100, answer: 27, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.ADD, numB: 100, answer: 26, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.ADD, numB: 100, answer: 25, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.ADD, numB: 100, answer: 24, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.ADD, numB: 100, answer: 23, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.ADD, numB: 100, answer: 22, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.ADD, numB: 100, answer: 21, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 100, answer: 20, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 100, answer: 19, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 100, answer: 18, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 100, answer: 17, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.ADD, numB: 100, answer: 16, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.ADD, numB: 100, answer: 15, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.ADD, numB: 100, answer: 14, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.ADD, numB: 100, answer: 13, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.ADD, numB: 100, answer: 12, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.ADD, numB: 100, answer: 11, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 100, answer: 10, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 100, answer: 9, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 100, answer: 8, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 100, answer: 7, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.ADD, numB: 100, answer: 6, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.ADD, numB: 100, answer: 5, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.ADD, numB: 100, answer: 4, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.ADD, numB: 100, answer: 3, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.ADD, numB: 100, answer: 2, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.ADD, numB: 100, answer: 1, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 100, sign: mathSymbols.ADD, numB: 100, answer: 0, format: types.Format.Equation5, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 100, answer: 100, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 100, answer: 99, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 100, answer: 98, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 100, answer: 97, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 100, answer: 96, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 100, answer: 95, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 100, answer: 94, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 100, answer: 93, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 100, answer: 92, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 100, answer: 91, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 100, answer: 90, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 100, answer: 89, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 100, answer: 88, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 100, answer: 87, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 100, answer: 86, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 100, answer: 85, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 100, answer: 84, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 100, answer: 83, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 100, answer: 82, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 100, answer: 81, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 100, answer: 80, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 100, answer: 79, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 100, answer: 78, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 100, answer: 77, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.ADD, numB: 100, answer: 76, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.ADD, numB: 100, answer: 75, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.ADD, numB: 100, answer: 74, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.ADD, numB: 100, answer: 73, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.ADD, numB: 100, answer: 72, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.ADD, numB: 100, answer: 71, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 100, answer: 70, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 100, answer: 69, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 100, answer: 68, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 100, answer: 67, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.ADD, numB: 100, answer: 66, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.ADD, numB: 100, answer: 65, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.ADD, numB: 100, answer: 64, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.ADD, numB: 100, answer: 63, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.ADD, numB: 100, answer: 62, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.ADD, numB: 100, answer: 61, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 100, answer: 60, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 100, answer: 59, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 100, answer: 58, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 100, answer: 57, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.ADD, numB: 100, answer: 56, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.ADD, numB: 100, answer: 55, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.ADD, numB: 100, answer: 54, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.ADD, numB: 100, answer: 53, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.ADD, numB: 100, answer: 52, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.ADD, numB: 100, answer: 51, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 100, answer: 50, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 100, answer: 49, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 100, answer: 48, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 100, answer: 47, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.ADD, numB: 100, answer: 46, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.ADD, numB: 100, answer: 45, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.ADD, numB: 100, answer: 44, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.ADD, numB: 100, answer: 43, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.ADD, numB: 100, answer: 42, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.ADD, numB: 100, answer: 41, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 100, answer: 40, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 100, answer: 39, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 100, answer: 38, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 100, answer: 37, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.ADD, numB: 100, answer: 36, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.ADD, numB: 100, answer: 35, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.ADD, numB: 100, answer: 34, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.ADD, numB: 100, answer: 33, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.ADD, numB: 100, answer: 32, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.ADD, numB: 100, answer: 31, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 100, answer: 30, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 100, answer: 29, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 100, answer: 28, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 100, answer: 27, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.ADD, numB: 100, answer: 26, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.ADD, numB: 100, answer: 25, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.ADD, numB: 100, answer: 24, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.ADD, numB: 100, answer: 23, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.ADD, numB: 100, answer: 22, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.ADD, numB: 100, answer: 21, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 100, answer: 20, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 100, answer: 19, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 100, answer: 18, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 100, answer: 17, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.ADD, numB: 100, answer: 16, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.ADD, numB: 100, answer: 15, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.ADD, numB: 100, answer: 14, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.ADD, numB: 100, answer: 13, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.ADD, numB: 100, answer: 12, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.ADD, numB: 100, answer: 11, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 100, answer: 10, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 100, answer: 9, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 100, answer: 8, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 100, answer: 7, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.ADD, numB: 100, answer: 6, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.ADD, numB: 100, answer: 5, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.ADD, numB: 100, answer: 4, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.ADD, numB: 100, answer: 3, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.ADD, numB: 100, answer: 2, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.ADD, numB: 100, answer: 1, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 100, sign: mathSymbols.ADD, numB: 100, answer: 0, format: types.Format.Equation6, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 100, answer: 100, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 100, answer: 99, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 100, answer: 98, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 100, answer: 97, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 100, answer: 96, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 100, answer: 95, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 100, answer: 94, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 100, answer: 93, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 100, answer: 92, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 100, answer: 91, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 100, answer: 90, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 100, answer: 89, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 100, answer: 88, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 100, answer: 87, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 100, answer: 86, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 100, answer: 85, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 100, answer: 84, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 100, answer: 83, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 100, answer: 82, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 100, answer: 81, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 100, answer: 80, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 100, answer: 79, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 100, answer: 78, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 100, answer: 77, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.ADD, numB: 100, answer: 76, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.ADD, numB: 100, answer: 75, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.ADD, numB: 100, answer: 74, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.ADD, numB: 100, answer: 73, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.ADD, numB: 100, answer: 72, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.ADD, numB: 100, answer: 71, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 100, answer: 70, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 100, answer: 69, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 100, answer: 68, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 100, answer: 67, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.ADD, numB: 100, answer: 66, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.ADD, numB: 100, answer: 65, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.ADD, numB: 100, answer: 64, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.ADD, numB: 100, answer: 63, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.ADD, numB: 100, answer: 62, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.ADD, numB: 100, answer: 61, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 100, answer: 60, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 100, answer: 59, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 100, answer: 58, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 100, answer: 57, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.ADD, numB: 100, answer: 56, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.ADD, numB: 100, answer: 55, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.ADD, numB: 100, answer: 54, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.ADD, numB: 100, answer: 53, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.ADD, numB: 100, answer: 52, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.ADD, numB: 100, answer: 51, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 100, answer: 50, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 100, answer: 49, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 100, answer: 48, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 100, answer: 47, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.ADD, numB: 100, answer: 46, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.ADD, numB: 100, answer: 45, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.ADD, numB: 100, answer: 44, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.ADD, numB: 100, answer: 43, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.ADD, numB: 100, answer: 42, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.ADD, numB: 100, answer: 41, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 100, answer: 40, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 100, answer: 39, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 100, answer: 38, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 100, answer: 37, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.ADD, numB: 100, answer: 36, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.ADD, numB: 100, answer: 35, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.ADD, numB: 100, answer: 34, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.ADD, numB: 100, answer: 33, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.ADD, numB: 100, answer: 32, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.ADD, numB: 100, answer: 31, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 100, answer: 30, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 100, answer: 29, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 100, answer: 28, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 100, answer: 27, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.ADD, numB: 100, answer: 26, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.ADD, numB: 100, answer: 25, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.ADD, numB: 100, answer: 24, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.ADD, numB: 100, answer: 23, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.ADD, numB: 100, answer: 22, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.ADD, numB: 100, answer: 21, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 100, answer: 20, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 100, answer: 19, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 100, answer: 18, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 100, answer: 17, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.ADD, numB: 100, answer: 16, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.ADD, numB: 100, answer: 15, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.ADD, numB: 100, answer: 14, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.ADD, numB: 100, answer: 13, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.ADD, numB: 100, answer: 12, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.ADD, numB: 100, answer: 11, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 100, answer: 10, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 100, answer: 9, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 100, answer: 8, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 100, answer: 7, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.ADD, numB: 100, answer: 6, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.ADD, numB: 100, answer: 5, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.ADD, numB: 100, answer: 4, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.ADD, numB: 100, answer: 3, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.ADD, numB: 100, answer: 2, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.ADD, numB: 100, answer: 1, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 100, sign: mathSymbols.ADD, numB: 100, answer: 0, format: types.Format.Equation7, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 100, answer: 100, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 100, answer: 99, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 100, answer: 98, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 100, answer: 97, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 100, answer: 96, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 100, answer: 95, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 100, answer: 94, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 100, answer: 93, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 100, answer: 92, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 100, answer: 91, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 100, answer: 90, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 100, answer: 89, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 100, answer: 88, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 100, answer: 87, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 100, answer: 86, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 100, answer: 85, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 100, answer: 84, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 100, answer: 83, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 100, answer: 82, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 100, answer: 81, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 100, answer: 80, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 100, answer: 79, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 100, answer: 78, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 100, answer: 77, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.ADD, numB: 100, answer: 76, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.ADD, numB: 100, answer: 75, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.ADD, numB: 100, answer: 74, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.ADD, numB: 100, answer: 73, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.ADD, numB: 100, answer: 72, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.ADD, numB: 100, answer: 71, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 100, answer: 70, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 100, answer: 69, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 100, answer: 68, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 100, answer: 67, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.ADD, numB: 100, answer: 66, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.ADD, numB: 100, answer: 65, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.ADD, numB: 100, answer: 64, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.ADD, numB: 100, answer: 63, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.ADD, numB: 100, answer: 62, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.ADD, numB: 100, answer: 61, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 100, answer: 60, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 100, answer: 59, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 100, answer: 58, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 100, answer: 57, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.ADD, numB: 100, answer: 56, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.ADD, numB: 100, answer: 55, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.ADD, numB: 100, answer: 54, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.ADD, numB: 100, answer: 53, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.ADD, numB: 100, answer: 52, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.ADD, numB: 100, answer: 51, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 100, answer: 50, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 100, answer: 49, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 100, answer: 48, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 100, answer: 47, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.ADD, numB: 100, answer: 46, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.ADD, numB: 100, answer: 45, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.ADD, numB: 100, answer: 44, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.ADD, numB: 100, answer: 43, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.ADD, numB: 100, answer: 42, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.ADD, numB: 100, answer: 41, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 100, answer: 40, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 100, answer: 39, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 100, answer: 38, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 100, answer: 37, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.ADD, numB: 100, answer: 36, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.ADD, numB: 100, answer: 35, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.ADD, numB: 100, answer: 34, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.ADD, numB: 100, answer: 33, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.ADD, numB: 100, answer: 32, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.ADD, numB: 100, answer: 31, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 100, answer: 30, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 100, answer: 29, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 100, answer: 28, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 100, answer: 27, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.ADD, numB: 100, answer: 26, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.ADD, numB: 100, answer: 25, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.ADD, numB: 100, answer: 24, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.ADD, numB: 100, answer: 23, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.ADD, numB: 100, answer: 22, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.ADD, numB: 100, answer: 21, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 100, answer: 20, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 100, answer: 19, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 100, answer: 18, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 100, answer: 17, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.ADD, numB: 100, answer: 16, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.ADD, numB: 100, answer: 15, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.ADD, numB: 100, answer: 14, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.ADD, numB: 100, answer: 13, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.ADD, numB: 100, answer: 12, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.ADD, numB: 100, answer: 11, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 100, answer: 10, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 100, answer: 9, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 100, answer: 8, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 100, answer: 7, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.ADD, numB: 100, answer: 6, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.ADD, numB: 100, answer: 5, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.ADD, numB: 100, answer: 4, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.ADD, numB: 100, answer: 3, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.ADD, numB: 100, answer: 2, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.ADD, numB: 100, answer: 1, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question,
  {
    numA: 100, sign: mathSymbols.ADD, numB: 100, answer: 0, format: types.Format.Equation8, hint: types.Hint.HUNDRED_SQUARE
  } as types.Question
];

export const adding10Questions: types.Question[] = [
  {
    numA: 0, sign: mathSymbols.ADD, numB: 10, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 10, answer: 11, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 10, answer: 12, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 10, answer: 13, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 10, answer: 14, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 10, answer: 15, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 10, answer: 16, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 10, answer: 17, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 10, answer: 18, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 10, answer: 19, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 20, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 10, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 10, answer: 11, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 10, answer: 12, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 10, answer: 13, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 10, answer: 14, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 10, answer: 15, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 10, answer: 16, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 10, answer: 17, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 10, answer: 18, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 10, answer: 19, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 20, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 10, answer: 10, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 10, answer: 11, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 10, answer: 12, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 10, answer: 13, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 10, answer: 14, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 10, answer: 15, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 10, answer: 16, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 10, answer: 17, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 10, answer: 18, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 10, answer: 19, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 20, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 10, answer: 10, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 10, answer: 11, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 10, answer: 12, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 10, answer: 13, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 10, answer: 14, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 10, answer: 15, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 10, answer: 16, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 10, answer: 17, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 10, answer: 18, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 10, answer: 19, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 20, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question
];

export const addWithin10Questions: types.Question[] = [
  {
    numA: 0, sign: mathSymbols.ADD, numB: 0, answer: 0, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 1, answer: 1, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 2, answer: 2, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 3, answer: 3, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 4, answer: 4, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 5, answer: 5, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 6, answer: 6, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 7, answer: 7, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 8, answer: 8, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 9, answer: 9, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 10, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 0, answer: 1, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 1, answer: 2, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 2, answer: 3, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 3, answer: 4, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 4, answer: 5, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 5, answer: 6, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 6, answer: 7, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 7, answer: 8, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 8, answer: 9, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 9, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 0, answer: 2, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 1, answer: 3, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 2, answer: 4, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 3, answer: 5, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 4, answer: 6, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 5, answer: 7, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 6, answer: 8, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 7, answer: 9, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 8, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 0, answer: 3, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 1, answer: 4, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 2, answer: 5, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 3, answer: 6, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 4, answer: 7, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 5, answer: 8, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 6, answer: 9, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 7, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 0, answer: 4, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 1, answer: 5, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 2, answer: 6, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 3, answer: 7, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 4, answer: 8, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 5, answer: 9, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 6, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 0, answer: 5, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 1, answer: 6, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 2, answer: 7, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 3, answer: 8, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 4, answer: 9, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 5, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 0, answer: 6, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 1, answer: 7, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 2, answer: 8, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 3, answer: 9, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 4, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 0, answer: 7, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 1, answer: 8, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 2, answer: 9, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 3, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 0, answer: 8, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 1, answer: 9, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 2, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 0, answer: 9, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 1, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 0, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 0, answer: 0, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 1, answer: 1, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 2, answer: 2, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 3, answer: 3, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 4, answer: 4, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 5, answer: 5, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 6, answer: 6, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 7, answer: 7, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 8, answer: 8, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 9, answer: 9, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 10, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 0, answer: 1, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 1, answer: 2, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 2, answer: 3, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 3, answer: 4, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 4, answer: 5, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 5, answer: 6, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 6, answer: 7, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 7, answer: 8, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 8, answer: 9, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 9, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 0, answer: 2, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 1, answer: 3, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 2, answer: 4, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 3, answer: 5, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 4, answer: 6, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 5, answer: 7, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 6, answer: 8, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 7, answer: 9, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 8, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 0, answer: 3, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 1, answer: 4, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 2, answer: 5, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 3, answer: 6, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 4, answer: 7, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 5, answer: 8, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 6, answer: 9, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 7, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 0, answer: 4, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 1, answer: 5, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 2, answer: 6, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 3, answer: 7, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 4, answer: 8, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 5, answer: 9, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 6, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 0, answer: 5, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 1, answer: 6, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 2, answer: 7, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 3, answer: 8, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 4, answer: 9, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 5, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 0, answer: 6, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 1, answer: 7, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 2, answer: 8, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 3, answer: 9, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 4, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 0, answer: 7, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 1, answer: 8, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 2, answer: 9, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 3, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 0, answer: 8, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 1, answer: 9, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 2, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 0, answer: 9, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 1, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 0, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question
];

export const addTwoTensWithin100Questions: types.Question[] = [
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 20, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 10, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 30, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 20, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 10, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 40, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 30, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 20, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 10, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 50, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 40, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 30, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 20, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 10, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 60, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 50, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 40, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 30, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 20, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 10, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 70, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 60, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 50, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 40, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 30, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 20, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 10, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 80, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 70, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 60, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 50, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 40, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 30, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 20, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 10, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 90, answer: 100, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 80, answer: 100, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 70, answer: 100, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 60, answer: 100, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 50, answer: 100, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 40, answer: 100, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 30, answer: 100, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 20, answer: 100, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 10, answer: 100, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 20, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 10, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 30, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 20, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 10, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 40, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 30, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 20, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 10, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 50, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 40, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 30, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 20, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 10, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 60, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 50, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 40, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 30, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 20, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 10, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 70, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 60, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 50, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 40, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 30, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 20, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 10, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 80, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 70, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 60, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 50, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 40, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 30, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 20, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 10, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 90, answer: 100, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 80, answer: 100, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 70, answer: 100, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 60, answer: 100, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 50, answer: 100, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 40, answer: 100, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 30, answer: 100, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 20, answer: 100, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 10, answer: 100, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question
];

export const addTensWithin100Questions: types.Question[] = [
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 11, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 12, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 13, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 14, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 15, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 16, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 17, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 18, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 19, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 20, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 21, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 22, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 23, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 24, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 25, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 26, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 27, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 28, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 29, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 30, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 31, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 32, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 33, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 34, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 35, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 36, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 37, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 38, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 39, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 40, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 41, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 42, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 43, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 44, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 45, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 46, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 47, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 48, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 49, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 50, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 51, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 52, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 53, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 54, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 55, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 56, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 57, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 58, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 59, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 60, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 61, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 62, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 63, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 64, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 65, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 66, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 67, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 68, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 69, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 70, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 71, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 72, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 73, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 74, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 75, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 76, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 77, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 78, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 79, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 80, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 81, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 82, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 83, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 84, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 85, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 86, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 87, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 88, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 89, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 10, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 11, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 12, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 13, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 14, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 15, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 16, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 17, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 18, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 19, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 20, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 21, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 22, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 23, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 24, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 25, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 26, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 27, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 28, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 29, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 30, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 31, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 32, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 33, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 34, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 35, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 36, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 37, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 38, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 39, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 40, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 41, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 42, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 43, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 44, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 45, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 46, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 47, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 48, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 49, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 50, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 51, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 52, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 53, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 54, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 55, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 56, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 57, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 58, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 59, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 60, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 61, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 62, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 63, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 64, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 65, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 66, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 67, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 68, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 69, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 70, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 71, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 72, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 73, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 74, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 75, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 76, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 77, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 78, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 79, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 10, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 11, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 12, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 13, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 14, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 15, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 16, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 17, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 18, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 19, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 20, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 21, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 22, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 23, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 24, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 25, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 26, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 27, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 28, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 29, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 30, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 31, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 32, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 33, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 34, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 35, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 36, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 37, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 38, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 39, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 40, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 41, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 42, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 43, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 44, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 45, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 46, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 47, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 48, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 49, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 50, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 51, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 52, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 53, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 54, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 55, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 56, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 57, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 58, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 59, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 60, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 61, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 62, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 63, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 64, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 65, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 66, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 67, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 68, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 69, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 10, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 11, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 12, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 13, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 14, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 15, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 16, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 17, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 18, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 19, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 20, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 21, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 22, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 23, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 24, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 25, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 26, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 27, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 28, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 29, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 30, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 31, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 32, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 33, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 34, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 35, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 36, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 37, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 38, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 39, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 40, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 41, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 42, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 43, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 44, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 45, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 46, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 47, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 48, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 49, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 50, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 51, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 52, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 53, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 54, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 55, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 56, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 57, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 58, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 59, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 10, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 11, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 12, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 13, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 14, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 15, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 16, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 17, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 18, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 19, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 20, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 21, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 22, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 23, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 24, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 25, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 26, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 27, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 28, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 29, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 30, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 31, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 32, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 33, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 34, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 35, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 36, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 37, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 38, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 39, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 40, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 41, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 42, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 43, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 44, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 45, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 46, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 47, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 48, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 49, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 10, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 11, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 12, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 13, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 14, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 15, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 16, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 17, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 18, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 19, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 20, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 21, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 22, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 23, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 24, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 25, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 26, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 27, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 28, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 29, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 30, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 31, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 32, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 33, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 34, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 35, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 36, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 37, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 38, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 39, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 10, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 11, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 12, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 13, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 14, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 15, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 16, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 17, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 18, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 19, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 20, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 21, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 22, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 23, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 24, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 25, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 26, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 27, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 28, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 29, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 10, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 11, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 12, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 13, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 14, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 15, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 16, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 17, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 18, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 19, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 11, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 12, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 13, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 14, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 15, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 16, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 17, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 18, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 19, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 20, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 21, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 22, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 23, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 24, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 25, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 26, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 27, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 28, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 29, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 30, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 31, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 32, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 33, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 34, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 35, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 36, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 37, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 38, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 39, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 40, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 41, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 42, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 43, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 44, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 45, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 46, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 47, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 48, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 49, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 50, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 51, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 52, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 53, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 54, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 55, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 56, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 57, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 58, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 59, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 60, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 61, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 62, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 63, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 64, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 65, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 66, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 67, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 68, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 69, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 70, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 71, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 72, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 73, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 74, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 75, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 76, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 77, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 78, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 79, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 80, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 81, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 82, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 83, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 84, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 85, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 86, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 87, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 88, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 89, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 10, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 11, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 12, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 13, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 14, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 15, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 16, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 17, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 18, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 19, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 20, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 21, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 22, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 23, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 24, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 25, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 26, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 27, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 28, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 29, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 30, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 31, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 32, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 33, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 34, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 35, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 36, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 37, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 38, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 39, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 40, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 41, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 42, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 43, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 44, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 45, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 46, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 47, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 48, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 49, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 50, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 51, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 52, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 53, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 54, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 55, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 56, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 57, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 58, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 59, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 60, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 61, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 62, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 63, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 64, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 65, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 66, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 67, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 68, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 69, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 70, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 71, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 72, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 73, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 74, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 75, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 76, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 77, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 78, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 79, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 10, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 11, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 12, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 13, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 14, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 15, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 16, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 17, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 18, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 19, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 20, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 21, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 22, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 23, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 24, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 25, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 26, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 27, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 28, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 29, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 30, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 31, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 32, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 33, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 34, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 35, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 36, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 37, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 38, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 39, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 40, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 41, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 42, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 43, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 44, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 45, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 46, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 47, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 48, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 49, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 50, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 51, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 52, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 53, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 54, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 55, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 56, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 57, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 58, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 59, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 60, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 61, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 62, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 63, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 64, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 65, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 66, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 67, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 68, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 69, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 10, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 11, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 12, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 13, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 14, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 15, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 16, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 17, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 18, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 19, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 20, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 21, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 22, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 23, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 24, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 25, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 26, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 27, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 28, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 29, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 30, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 31, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 32, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 33, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 34, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 35, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 36, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 37, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 38, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 39, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 40, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 41, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 42, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 43, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 44, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 45, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 46, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 47, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 48, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 49, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 50, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 51, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 52, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 53, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 54, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 55, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 56, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 57, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 58, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 59, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 10, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 11, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 12, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 13, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 14, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 15, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 16, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 17, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 18, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 19, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 20, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 21, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 22, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 23, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 24, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 25, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 26, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 27, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 28, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 29, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 30, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 31, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 32, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 33, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 34, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 35, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 36, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 37, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 38, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 39, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 40, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 41, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 42, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 43, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 44, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 45, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 46, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 47, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 48, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 49, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 10, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 11, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 12, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 13, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 14, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 15, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 16, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 17, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 18, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 19, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 20, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 21, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 22, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 23, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 24, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 25, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 26, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 27, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 28, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 29, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 30, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 31, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 32, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 33, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 34, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 35, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 36, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 37, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 38, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 39, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 10, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 11, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 12, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 13, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 14, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 15, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 16, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 17, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 18, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 19, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 20, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 21, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 22, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 23, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 24, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 25, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 26, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 27, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 28, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 29, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 10, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 11, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 12, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 13, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 14, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 15, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 16, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 17, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 18, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 19, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question
];

export const addOnesWithin20Questions: types.Question[] = [
  {
    numA: 10, sign: mathSymbols.ADD, numB: 0, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 1, answer: 11, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 2, answer: 12, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 3, answer: 13, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 4, answer: 14, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 5, answer: 15, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 6, answer: 16, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 7, answer: 17, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 8, answer: 18, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 9, answer: 19, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 20, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 0, answer: 11, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 1, answer: 12, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 2, answer: 13, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 3, answer: 14, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 4, answer: 15, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 5, answer: 16, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 6, answer: 17, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 7, answer: 18, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 8, answer: 19, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 9, answer: 20, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 0, answer: 12, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 1, answer: 13, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 2, answer: 14, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 3, answer: 15, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 4, answer: 16, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 5, answer: 17, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 6, answer: 18, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 7, answer: 19, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 8, answer: 20, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 0, answer: 13, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 1, answer: 14, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 2, answer: 15, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 3, answer: 16, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 4, answer: 17, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 5, answer: 18, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 6, answer: 19, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 7, answer: 20, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 0, answer: 14, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 1, answer: 15, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 2, answer: 16, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 3, answer: 17, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 4, answer: 18, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 5, answer: 19, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 6, answer: 20, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 0, answer: 15, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 1, answer: 16, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 2, answer: 17, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 3, answer: 18, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 4, answer: 19, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 5, answer: 20, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 0, answer: 16, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 1, answer: 17, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 2, answer: 18, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 3, answer: 19, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 4, answer: 20, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 0, answer: 17, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 1, answer: 18, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 2, answer: 19, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 3, answer: 20, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 0, answer: 18, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 1, answer: 19, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 2, answer: 20, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 0, answer: 19, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 1, answer: 20, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 0, answer: 20, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 0, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 1, answer: 11, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 2, answer: 12, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 3, answer: 13, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 4, answer: 14, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 5, answer: 15, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 6, answer: 16, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 7, answer: 17, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 8, answer: 18, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 9, answer: 19, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 20, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 0, answer: 11, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 1, answer: 12, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 2, answer: 13, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 3, answer: 14, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 4, answer: 15, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 5, answer: 16, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 6, answer: 17, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 7, answer: 18, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 8, answer: 19, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 9, answer: 20, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 0, answer: 12, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 1, answer: 13, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 2, answer: 14, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 3, answer: 15, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 4, answer: 16, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 5, answer: 17, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 6, answer: 18, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 7, answer: 19, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 8, answer: 20, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 0, answer: 13, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 1, answer: 14, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 2, answer: 15, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 3, answer: 16, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 4, answer: 17, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 5, answer: 18, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 6, answer: 19, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 7, answer: 20, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 0, answer: 14, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 1, answer: 15, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 2, answer: 16, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 3, answer: 17, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 4, answer: 18, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 5, answer: 19, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 6, answer: 20, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 0, answer: 15, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 1, answer: 16, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 2, answer: 17, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 3, answer: 18, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 4, answer: 19, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 5, answer: 20, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 0, answer: 16, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 1, answer: 17, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 2, answer: 18, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 3, answer: 19, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 4, answer: 20, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 0, answer: 17, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 1, answer: 18, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 2, answer: 19, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 3, answer: 20, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 0, answer: 18, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 1, answer: 19, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 2, answer: 20, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 0, answer: 19, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 1, answer: 20, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 0, answer: 20, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 0, answer: 10, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 1, answer: 11, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 2, answer: 12, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 3, answer: 13, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 4, answer: 14, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 5, answer: 15, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 6, answer: 16, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 7, answer: 17, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 8, answer: 18, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 9, answer: 19, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 20, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 0, answer: 11, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 1, answer: 12, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 2, answer: 13, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 3, answer: 14, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 4, answer: 15, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 5, answer: 16, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 6, answer: 17, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 7, answer: 18, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 8, answer: 19, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 9, answer: 20, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 0, answer: 12, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 1, answer: 13, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 2, answer: 14, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 3, answer: 15, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 4, answer: 16, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 5, answer: 17, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 6, answer: 18, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 7, answer: 19, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 8, answer: 20, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 0, answer: 13, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 1, answer: 14, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 2, answer: 15, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 3, answer: 16, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 4, answer: 17, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 5, answer: 18, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 6, answer: 19, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 7, answer: 20, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 0, answer: 14, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 1, answer: 15, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 2, answer: 16, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 3, answer: 17, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 4, answer: 18, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 5, answer: 19, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 6, answer: 20, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 0, answer: 15, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 1, answer: 16, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 2, answer: 17, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 3, answer: 18, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 4, answer: 19, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 5, answer: 20, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 0, answer: 16, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 1, answer: 17, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 2, answer: 18, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 3, answer: 19, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 4, answer: 20, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 0, answer: 17, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 1, answer: 18, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 2, answer: 19, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 3, answer: 20, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 0, answer: 18, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 1, answer: 19, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 2, answer: 20, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 0, answer: 19, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 1, answer: 20, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 0, answer: 20, format: types.Format.Equation3, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 0, answer: 10, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 1, answer: 11, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 2, answer: 12, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 3, answer: 13, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 4, answer: 14, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 5, answer: 15, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 6, answer: 16, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 7, answer: 17, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 8, answer: 18, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 9, answer: 19, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 20, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 0, answer: 11, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 1, answer: 12, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 2, answer: 13, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 3, answer: 14, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 4, answer: 15, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 5, answer: 16, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 6, answer: 17, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 7, answer: 18, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 8, answer: 19, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 9, answer: 20, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 0, answer: 12, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 1, answer: 13, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 2, answer: 14, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 3, answer: 15, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 4, answer: 16, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 5, answer: 17, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 6, answer: 18, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 7, answer: 19, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 8, answer: 20, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 0, answer: 13, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 1, answer: 14, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 2, answer: 15, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 3, answer: 16, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 4, answer: 17, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 5, answer: 18, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 6, answer: 19, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 7, answer: 20, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 0, answer: 14, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 1, answer: 15, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 2, answer: 16, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 3, answer: 17, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 4, answer: 18, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 5, answer: 19, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 6, answer: 20, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 0, answer: 15, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 1, answer: 16, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 2, answer: 17, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 3, answer: 18, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 4, answer: 19, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 5, answer: 20, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 0, answer: 16, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 1, answer: 17, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 2, answer: 18, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 3, answer: 19, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 4, answer: 20, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 0, answer: 17, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 1, answer: 18, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 2, answer: 19, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 3, answer: 20, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 0, answer: 18, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 1, answer: 19, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 2, answer: 20, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 0, answer: 19, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.ADD, numB: 1, answer: 20, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 0, answer: 20, format: types.Format.Equation4, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question
];

export const addOnesWithin100Questions: types.Question[] = [
  {
    numA: 10, sign: mathSymbols.ADD, numB: 1, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 2, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 3, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 4, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 5, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 6, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 7, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 8, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 9, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 1, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 2, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 3, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 4, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 5, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 6, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 7, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 8, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 1, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 2, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 3, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 4, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 5, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 6, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 7, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 1, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 2, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 3, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 4, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 5, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 6, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 1, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 2, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 3, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 4, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 5, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 1, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 2, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 3, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 4, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 1, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 2, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 3, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 1, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 2, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 1, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 1, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 2, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 3, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 4, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 5, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 6, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 7, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 8, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 9, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 1, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 2, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 3, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 4, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 5, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 6, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 7, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 8, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 1, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 2, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 3, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 4, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 5, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 6, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 7, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 1, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 2, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 3, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 4, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 5, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 6, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.ADD, numB: 1, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.ADD, numB: 2, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.ADD, numB: 3, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.ADD, numB: 4, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.ADD, numB: 5, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.ADD, numB: 1, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.ADD, numB: 2, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.ADD, numB: 3, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.ADD, numB: 4, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.ADD, numB: 1, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.ADD, numB: 2, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.ADD, numB: 3, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.ADD, numB: 1, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.ADD, numB: 2, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.ADD, numB: 1, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 1, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 2, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 3, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 4, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 5, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 6, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 7, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 8, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 9, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 1, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 2, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 3, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 4, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 5, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 6, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 7, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 8, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 1, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 2, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 3, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 4, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 5, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 6, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 7, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 1, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 2, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 3, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 4, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 5, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 6, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.ADD, numB: 1, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.ADD, numB: 2, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.ADD, numB: 3, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.ADD, numB: 4, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.ADD, numB: 5, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.ADD, numB: 1, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.ADD, numB: 2, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.ADD, numB: 3, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.ADD, numB: 4, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.ADD, numB: 1, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.ADD, numB: 2, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.ADD, numB: 3, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.ADD, numB: 1, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.ADD, numB: 2, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.ADD, numB: 1, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 1, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 2, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 3, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 4, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 5, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 6, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 7, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 8, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 9, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 1, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 2, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 3, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 4, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 5, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 6, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 7, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 8, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 1, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 2, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 3, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 4, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 5, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 6, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 7, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 1, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 2, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 3, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 4, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 5, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 6, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.ADD, numB: 1, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.ADD, numB: 2, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.ADD, numB: 3, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.ADD, numB: 4, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.ADD, numB: 5, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.ADD, numB: 1, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.ADD, numB: 2, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.ADD, numB: 3, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.ADD, numB: 4, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.ADD, numB: 1, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.ADD, numB: 2, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.ADD, numB: 3, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.ADD, numB: 1, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.ADD, numB: 2, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.ADD, numB: 1, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 1, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 2, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 3, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 4, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 5, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 6, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 7, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 8, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 9, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 1, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 2, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 3, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 4, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 5, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 6, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 7, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 8, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 1, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 2, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 3, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 4, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 5, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 6, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 7, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 1, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 2, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 3, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 4, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 5, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 6, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.ADD, numB: 1, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.ADD, numB: 2, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.ADD, numB: 3, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.ADD, numB: 4, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.ADD, numB: 5, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.ADD, numB: 1, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.ADD, numB: 2, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.ADD, numB: 3, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.ADD, numB: 4, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.ADD, numB: 1, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.ADD, numB: 2, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.ADD, numB: 3, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.ADD, numB: 1, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.ADD, numB: 2, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.ADD, numB: 1, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 1, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 2, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 3, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 4, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 5, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 6, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 7, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 8, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 9, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 1, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 2, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 3, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 4, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 5, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 6, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 7, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 8, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 1, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 2, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 3, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 4, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 5, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 6, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 7, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 1, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 2, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 3, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 4, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 5, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 6, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.ADD, numB: 1, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.ADD, numB: 2, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.ADD, numB: 3, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.ADD, numB: 4, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.ADD, numB: 5, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.ADD, numB: 1, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.ADD, numB: 2, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.ADD, numB: 3, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.ADD, numB: 4, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.ADD, numB: 1, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.ADD, numB: 2, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.ADD, numB: 3, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.ADD, numB: 1, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.ADD, numB: 2, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.ADD, numB: 1, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 1, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 2, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 3, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 4, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 5, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 6, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 7, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 8, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 9, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 1, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 2, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 3, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 4, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 5, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 6, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 7, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 8, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 1, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 2, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 3, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 4, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 5, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 6, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 7, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 1, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 2, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 3, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 4, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 5, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 6, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.ADD, numB: 1, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.ADD, numB: 2, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.ADD, numB: 3, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.ADD, numB: 4, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.ADD, numB: 5, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.ADD, numB: 1, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.ADD, numB: 2, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.ADD, numB: 3, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.ADD, numB: 4, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.ADD, numB: 1, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.ADD, numB: 2, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.ADD, numB: 3, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.ADD, numB: 1, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.ADD, numB: 2, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.ADD, numB: 1, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 1, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 2, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 3, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 4, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 5, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 6, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 7, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 8, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 9, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 1, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 2, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 3, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 4, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 5, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 6, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 7, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 8, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 1, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 2, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 3, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 4, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 5, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 6, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 7, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 1, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 2, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 3, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 4, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 5, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 6, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.ADD, numB: 1, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.ADD, numB: 2, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.ADD, numB: 3, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.ADD, numB: 4, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.ADD, numB: 5, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.ADD, numB: 1, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.ADD, numB: 2, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.ADD, numB: 3, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.ADD, numB: 4, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.ADD, numB: 1, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.ADD, numB: 2, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.ADD, numB: 3, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.ADD, numB: 1, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.ADD, numB: 2, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.ADD, numB: 1, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 1, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 2, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 3, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 4, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 5, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 6, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 7, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 8, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 9, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 1, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 2, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 3, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 4, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 5, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 6, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 7, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 8, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 1, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 2, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 3, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 4, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 5, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 6, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 7, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 1, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 2, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 3, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 4, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 5, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 6, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.ADD, numB: 1, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.ADD, numB: 2, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.ADD, numB: 3, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.ADD, numB: 4, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.ADD, numB: 5, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.ADD, numB: 1, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.ADD, numB: 2, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.ADD, numB: 3, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.ADD, numB: 4, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.ADD, numB: 1, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.ADD, numB: 2, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.ADD, numB: 3, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.ADD, numB: 1, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.ADD, numB: 2, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.ADD, numB: 1, answer: 99, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 1, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 2, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 3, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 4, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 5, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 6, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 7, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 8, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 9, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 1, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 2, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 3, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 4, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 5, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 6, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 7, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.ADD, numB: 8, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 1, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 2, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 3, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 4, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 5, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 6, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.ADD, numB: 7, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 1, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 2, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 3, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 4, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 5, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.ADD, numB: 6, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 1, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 2, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 3, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 4, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.ADD, numB: 5, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 1, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 2, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 3, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.ADD, numB: 4, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 1, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 2, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.ADD, numB: 3, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 1, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.ADD, numB: 2, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.ADD, numB: 1, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 1, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 2, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 3, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 4, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 5, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 6, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 7, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 8, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.ADD, numB: 9, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 1, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 2, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 3, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 4, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 5, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 6, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 7, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.ADD, numB: 8, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 1, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 2, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 3, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 4, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 5, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 6, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.ADD, numB: 7, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 1, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 2, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 3, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 4, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 5, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.ADD, numB: 6, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.ADD, numB: 1, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.ADD, numB: 2, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.ADD, numB: 3, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.ADD, numB: 4, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.ADD, numB: 5, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.ADD, numB: 1, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.ADD, numB: 2, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.ADD, numB: 3, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.ADD, numB: 4, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.ADD, numB: 1, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.ADD, numB: 2, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.ADD, numB: 3, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.ADD, numB: 1, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.ADD, numB: 2, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.ADD, numB: 1, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 1, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 2, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 3, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 4, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 5, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 6, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 7, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 8, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.ADD, numB: 9, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 1, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 2, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 3, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 4, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 5, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 6, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 7, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.ADD, numB: 8, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 1, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 2, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 3, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 4, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 5, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 6, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.ADD, numB: 7, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 1, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 2, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 3, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 4, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 5, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.ADD, numB: 6, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.ADD, numB: 1, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.ADD, numB: 2, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.ADD, numB: 3, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.ADD, numB: 4, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.ADD, numB: 5, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.ADD, numB: 1, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.ADD, numB: 2, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.ADD, numB: 3, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.ADD, numB: 4, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.ADD, numB: 1, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.ADD, numB: 2, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.ADD, numB: 3, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.ADD, numB: 1, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.ADD, numB: 2, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.ADD, numB: 1, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 1, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 2, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 3, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 4, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 5, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 6, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 7, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 8, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.ADD, numB: 9, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 1, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 2, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 3, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 4, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 5, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 6, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 7, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.ADD, numB: 8, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 1, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 2, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 3, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 4, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 5, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 6, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.ADD, numB: 7, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 1, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 2, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 3, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 4, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 5, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.ADD, numB: 6, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.ADD, numB: 1, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.ADD, numB: 2, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.ADD, numB: 3, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.ADD, numB: 4, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.ADD, numB: 5, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.ADD, numB: 1, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.ADD, numB: 2, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.ADD, numB: 3, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.ADD, numB: 4, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.ADD, numB: 1, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.ADD, numB: 2, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.ADD, numB: 3, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.ADD, numB: 1, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.ADD, numB: 2, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.ADD, numB: 1, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 1, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 2, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 3, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 4, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 5, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 6, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 7, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 8, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.ADD, numB: 9, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 1, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 2, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 3, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 4, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 5, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 6, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 7, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.ADD, numB: 8, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 1, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 2, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 3, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 4, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 5, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 6, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.ADD, numB: 7, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 1, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 2, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 3, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 4, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 5, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.ADD, numB: 6, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.ADD, numB: 1, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.ADD, numB: 2, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.ADD, numB: 3, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.ADD, numB: 4, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.ADD, numB: 5, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.ADD, numB: 1, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.ADD, numB: 2, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.ADD, numB: 3, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.ADD, numB: 4, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.ADD, numB: 1, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.ADD, numB: 2, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.ADD, numB: 3, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.ADD, numB: 1, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.ADD, numB: 2, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.ADD, numB: 1, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 1, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 2, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 3, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 4, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 5, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 6, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 7, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 8, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.ADD, numB: 9, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 1, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 2, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 3, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 4, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 5, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 6, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 7, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.ADD, numB: 8, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 1, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 2, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 3, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 4, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 5, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 6, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.ADD, numB: 7, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 1, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 2, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 3, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 4, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 5, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.ADD, numB: 6, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.ADD, numB: 1, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.ADD, numB: 2, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.ADD, numB: 3, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.ADD, numB: 4, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.ADD, numB: 5, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.ADD, numB: 1, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.ADD, numB: 2, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.ADD, numB: 3, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.ADD, numB: 4, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.ADD, numB: 1, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.ADD, numB: 2, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.ADD, numB: 3, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.ADD, numB: 1, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.ADD, numB: 2, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.ADD, numB: 1, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 1, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 2, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 3, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 4, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 5, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 6, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 7, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 8, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.ADD, numB: 9, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 1, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 2, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 3, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 4, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 5, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 6, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 7, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.ADD, numB: 8, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 1, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 2, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 3, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 4, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 5, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 6, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.ADD, numB: 7, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 1, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 2, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 3, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 4, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 5, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.ADD, numB: 6, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.ADD, numB: 1, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.ADD, numB: 2, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.ADD, numB: 3, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.ADD, numB: 4, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.ADD, numB: 5, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.ADD, numB: 1, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.ADD, numB: 2, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.ADD, numB: 3, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.ADD, numB: 4, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.ADD, numB: 1, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.ADD, numB: 2, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.ADD, numB: 3, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.ADD, numB: 1, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.ADD, numB: 2, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.ADD, numB: 1, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 1, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 2, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 3, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 4, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 5, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 6, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 7, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 8, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.ADD, numB: 9, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 1, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 2, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 3, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 4, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 5, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 6, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 7, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.ADD, numB: 8, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 1, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 2, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 3, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 4, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 5, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 6, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.ADD, numB: 7, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 1, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 2, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 3, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 4, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 5, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.ADD, numB: 6, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.ADD, numB: 1, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.ADD, numB: 2, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.ADD, numB: 3, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.ADD, numB: 4, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.ADD, numB: 5, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.ADD, numB: 1, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.ADD, numB: 2, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.ADD, numB: 3, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.ADD, numB: 4, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.ADD, numB: 1, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.ADD, numB: 2, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.ADD, numB: 3, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.ADD, numB: 1, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.ADD, numB: 2, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.ADD, numB: 1, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 1, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 2, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 3, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 4, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 5, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 6, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 7, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 8, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.ADD, numB: 9, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 1, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 2, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 3, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 4, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 5, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 6, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 7, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.ADD, numB: 8, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 1, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 2, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 3, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 4, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 5, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 6, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.ADD, numB: 7, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 1, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 2, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 3, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 4, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 5, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.ADD, numB: 6, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.ADD, numB: 1, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.ADD, numB: 2, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.ADD, numB: 3, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.ADD, numB: 4, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.ADD, numB: 5, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.ADD, numB: 1, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.ADD, numB: 2, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.ADD, numB: 3, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.ADD, numB: 4, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.ADD, numB: 1, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.ADD, numB: 2, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.ADD, numB: 3, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.ADD, numB: 1, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.ADD, numB: 2, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.ADD, numB: 1, answer: 99, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS
  } as types.Question
];

export const addAcross10Questions: types.Question[] = [
  {
    numA: 1, sign: mathSymbols.ADD, numB: 9, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 9, answer: 11, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 8, answer: 11, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 9, answer: 12, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 7, answer: 11, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 8, answer: 12, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 9, answer: 13, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 6, answer: 11, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 7, answer: 12, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 8, answer: 13, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 9, answer: 14, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 5, answer: 11, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 6, answer: 12, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 7, answer: 13, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 8, answer: 14, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 9, answer: 15, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 4, answer: 11, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 5, answer: 12, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 6, answer: 13, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 7, answer: 14, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 8, answer: 15, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 9, answer: 16, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 3, answer: 11, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 4, answer: 12, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 5, answer: 13, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 6, answer: 14, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 7, answer: 15, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 8, answer: 16, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 9, answer: 17, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 2, answer: 11, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 3, answer: 12, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 4, answer: 13, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 5, answer: 14, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 6, answer: 15, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 7, answer: 16, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 8, answer: 17, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 9, answer: 18, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 9, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 9, answer: 11, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 8, answer: 11, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 9, answer: 12, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 7, answer: 11, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 8, answer: 12, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 9, answer: 13, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 6, answer: 11, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 7, answer: 12, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 8, answer: 13, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 9, answer: 14, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 5, answer: 11, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 6, answer: 12, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 7, answer: 13, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 8, answer: 14, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 9, answer: 15, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 4, answer: 11, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 5, answer: 12, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 6, answer: 13, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 7, answer: 14, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 8, answer: 15, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 9, answer: 16, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 3, answer: 11, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 4, answer: 12, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 5, answer: 13, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 6, answer: 14, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 7, answer: 15, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 8, answer: 16, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 9, answer: 17, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 2, answer: 11, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 3, answer: 12, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 4, answer: 13, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 5, answer: 14, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 6, answer: 15, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 7, answer: 16, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 8, answer: 17, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 9, answer: 18, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question
];

export const nearDoublesQuestions: types.Question[] = [
  {
    numA: 1, sign: mathSymbols.ADD, numB: 0, answer: 1, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 2, answer: 3, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 1, answer: 3, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 3, answer: 5, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 2, answer: 5, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 4, answer: 7, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 3, answer: 7, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 5, answer: 9, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 4, answer: 9, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 6, answer: 11, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 5, answer: 11, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 7, answer: 13, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 6, answer: 13, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 8, answer: 15, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 7, answer: 15, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 9, answer: 17, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 8, answer: 17, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 10, answer: 19, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 9, answer: 19, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 0, answer: 1, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 2, answer: 3, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 1, answer: 3, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 3, answer: 5, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 2, answer: 5, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 4, answer: 7, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 3, answer: 7, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 5, answer: 9, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 4, answer: 9, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 6, answer: 11, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 5, answer: 11, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 7, answer: 13, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 6, answer: 13, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 8, answer: 15, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 7, answer: 15, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 9, answer: 17, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 8, answer: 17, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 10, answer: 19, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 9, answer: 19, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question
];

export const doublesQuestions: types.Question[] = [
  {
    numA: 0, sign: mathSymbols.ADD, numB: 0, answer: 0, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 1, answer: 2, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 2, answer: 4, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 3, answer: 6, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 4, answer: 8, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 5, answer: 10, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 6, answer: 12, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 7, answer: 14, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 8, answer: 16, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 9, answer: 18, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 20, format: types.Format.Equation1, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.ADD, numB: 0, answer: 0, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.ADD, numB: 1, answer: 2, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.ADD, numB: 2, answer: 4, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.ADD, numB: 3, answer: 6, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.ADD, numB: 4, answer: 8, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.ADD, numB: 5, answer: 10, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.ADD, numB: 6, answer: 12, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.ADD, numB: 7, answer: 14, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.ADD, numB: 8, answer: 16, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.ADD, numB: 9, answer: 18, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.ADD, numB: 10, answer: 20, format: types.Format.Equation2, hint: types.Hint.ADDITION_TEN_FRAME
  } as types.Question,
  {
    numA: 0, answer: 0, action: 'Double', format: types.Format.WordEquation, hint: types.Hint.DOUBLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 1, answer: 2, action: 'Double', format: types.Format.WordEquation, hint: types.Hint.DOUBLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 2, answer: 4, action: 'Double', format: types.Format.WordEquation, hint: types.Hint.DOUBLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 3, answer: 6, action: 'Double', format: types.Format.WordEquation, hint: types.Hint.DOUBLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 4, answer: 8, action: 'Double', format: types.Format.WordEquation, hint: types.Hint.DOUBLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 5, answer: 10, action: 'Double', format: types.Format.WordEquation, hint: types.Hint.DOUBLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 6, answer: 12, action: 'Double', format: types.Format.WordEquation, hint: types.Hint.DOUBLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 7, answer: 14, action: 'Double', format: types.Format.WordEquation, hint: types.Hint.DOUBLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 8, answer: 16, action: 'Double', format: types.Format.WordEquation, hint: types.Hint.DOUBLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 9, answer: 18, action: 'Double', format: types.Format.WordEquation, hint: types.Hint.DOUBLE_TEN_FRAMES
  } as types.Question,
  {
    numA: 10, answer: 20, action: 'Double', format: types.Format.WordEquation, hint: types.Hint.DOUBLE_TEN_FRAMES
  } as types.Question
];